import { FC } from "react";

import { trackEvent } from "../../../utils/amplitude";

import { FOLLOWING_QUERY_PARAM } from "components/constants";
import { PillBannerButton } from "components/footer/PillBannerButton";
import { type PresentationBannerColorType } from "components/footer/PresentationBanner";
import { t } from "i18n/i18n";
import { useAppDispatch } from "store/index";
import { viewStateActions } from "store/slices/view";
import { useQueryParamsManager } from "utils/routing";

interface StopFollowingButtonProps {
  color: PresentationBannerColorType;
}

export const StopFollowingButton: FC<StopFollowingButtonProps> = ({ color }) => {
  const { deleteQueryParams } = useQueryParamsManager();
  const dispatch = useAppDispatch();

  const onClick = () => {
    trackEvent("Presentation - Stop following", { eventCategory: "Button press" });
    deleteQueryParams([FOLLOWING_QUERY_PARAM]);
    dispatch(viewStateActions.setHasStudentLeftPresentation(false));
  };

  return (
    <PillBannerButton
      kind={`banner-${color}`}
      title={t("tooltip.stop_following")}
      onClick={onClick}
    >
      {t("common.stop")}
    </PillBannerButton>
  );
};
